import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AdvancedGenericOption } from '../../../../shared/types/signaturit/shared-types';

@Component({
  selector: 'signaturit-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input() id: string;

  @Input() labelName: string;

  @Input() placeholderName: string;

  @Input() isRequired: boolean = false;

  @Input() inputType: string;

  @Input() nameForm: string;

  @Input() inputWidth: string;

  @Input() inputValue: string;

  @Input() isDisabled: boolean = false;

  @Input() maxLength: string = '2000'; // For input string

  @Input() minLength: string = '0'; // For input string

  @Input() max: string = '9999999999'; // For input number

  @Input() min: string = '0'; // For input number

  @Input() innerHTMLLabel: InnerHTML;

  @Input() messageError: string = '';

  @Input() readOnly: boolean = false;

  @Input() validationType: string;

  @Input() patternInput: string;

  @Output('outputValue') outputValue: EventEmitter<string> = new EventEmitter<string>();

  @Output('outputValueTemplate') outputValueTemplate: EventEmitter<AdvancedGenericOption> = new EventEmitter<AdvancedGenericOption>();

  @Output('enterKeyPressed') enterKeyPressed: EventEmitter<any> = new EventEmitter<any>();

  @Output('emitCorrect') emitCorrect: EventEmitter<boolean> = new EventEmitter<boolean>();

  isPassword: boolean = false;

  iconPassword: string = 'visibility';

  isCorrect: boolean = true;

  showError: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.isPassword = this.inputType === 'password';
  }

  changeText(input): void {
    this.outputValue.emit(this.inputValue);
    this.outputValueTemplate.emit({ key: this.nameForm, value: this.inputValue });
    this.onBlur(input);
  }

  validateInput(event: KeyboardEvent): void {
    const HOME_KEY = 'Home';
    const END_KEY = 'End';
    const DIGIT_KEY = 'Digit';
    const BACKSPACE_KEY = 'Backspace';
    const NUMERIC_KEYBOARD = 'Numpad';
    const ARROW_LEFT = 'ArrowLeft';
    const ARROW_RIGHT = 'ArrowRight';
    const DELETE = 'Delete';
    const PASTE = 'KeyV';
    const COPY = 'KeyC';
    const CUT = 'KeyX';

    const hasDigitValidation = !event.code.includes(DIGIT_KEY) && !event.code.includes(BACKSPACE_KEY);
    const isNumericKeyboard = event.code.includes(NUMERIC_KEYBOARD);
    const isHomeOrEndKey = (event.code === HOME_KEY || event.code === END_KEY) && event.target instanceof HTMLInputElement;
    const isArrow = event.code === ARROW_LEFT || event.code === ARROW_RIGHT;
    const isDelete = event.code === DELETE;
    const isCopyPaste = event.ctrlKey && (event.code === PASTE || event.code === COPY || event.code === CUT);

    this.validateInputValue(event);

    const validation = {
      ['number']: () => {
        if (hasDigitValidation && !isNumericKeyboard && !isArrow && !isDelete && !isCopyPaste) {
          event.preventDefault();
        }
      },
      ['text']: () => {
        if (isHomeOrEndKey) {
          const target = event.target as HTMLInputElement;
          target.selectionStart = event.code === HOME_KEY ? 0 : target.value.length;
          target.selectionEnd = event.code === HOME_KEY ? 0 : target.value.length;
        }
      }
    }

    return validation[this.validationType]();
  }

  validateInputValue(event: KeyboardEvent): void {
    if (this.inputType === 'number') {
      const keyPressed = event.key;
      const forbiddenKeys = ['+', '-'];
      const valueMin = parseInt(this.min);
      const valueInput = parseInt(this.inputValue + keyPressed);

      if (forbiddenKeys.includes(event.key)) {
        event.preventDefault();
      }

      if (valueInput < valueMin) {
        event.preventDefault();
      }

      if (valueInput > parseInt(this.max)) {
        event.preventDefault();
      }
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.validationType) {
      this.validateInput(event);
    }
  }

  validateRegex(): void {
    if (this.patternInput) {
      const regex = RegExp(this.patternInput)
      this.isCorrect = regex.test(this.inputValue);
      this.emitCorrect.emit(this.isCorrect);
    }
  }

  onEnterKeyPressed(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.enterKeyPressed.emit();
    }
  }

  viewPassword(): void {
    if (this.iconPassword === 'visibility') {
      this.iconPassword = 'visibility_off';
      this.inputType = 'text';
    } else {
      this.iconPassword = 'visibility';
      this.inputType = 'password';
    }
  }

  onBlur(event): void {
    this.showError = !event.inputValue && event.isRequired ? true : false;
    this.validateRegex();
  }
}
